module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "holder"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "navigation",
    class: _vm.roleClass
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_vm._v("\n      " + _vm._s(_vm.$store.getters.rackShelfInfo) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "width": "300px"
    }
  }, [_c('material-input', {
    attrs: {
      "parentClass": "",
      "label": "ID или Название",
      "valueStr": _vm.searchStr
    },
    on: {
      "inputStr": _vm.inputStr
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "font-size": "14px",
      "padding-top": "10px"
    }
  }, [(_vm.$store.state.user.role === 'PM') ? _c('div', [_c('label', {
    attrs: {
      "for": "onlyNew"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyAdd),
      expression: "onlyAdd"
    }],
    attrs: {
      "type": "checkbox",
      "id": "onlyNew"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyAdd) ? _vm._i(_vm.onlyAdd, null) > -1 : (_vm.onlyAdd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyAdd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyAdd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyAdd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyAdd = $$c
        }
      }
    }
  }), _vm._v(" Только новые")]), _vm._v("\n                   \n              "), _c('label', {
    attrs: {
      "for": "onlyLost"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyRemove),
      expression: "onlyRemove"
    }],
    attrs: {
      "type": "checkbox",
      "id": "onlyLost"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyRemove) ? _vm._i(_vm.onlyRemove, null) > -1 : (_vm.onlyRemove)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyRemove,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyRemove = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyRemove = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyRemove = $$c
        }
      }
    }
  }), _vm._v(" Только ушедшие")]), _vm._v("\n                   \n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('div', [_c('label', {
    attrs: {
      "for": "onlyNeedRemoval"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyRemove),
      expression: "onlyRemove"
    }],
    attrs: {
      "type": "checkbox",
      "id": "onlyNeedRemoval"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyRemove) ? _vm._i(_vm.onlyRemove, null) > -1 : (_vm.onlyRemove)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyRemove,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyRemove = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyRemove = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyRemove = $$c
        }
      }
    }
  }), _vm._v("\n                Только те, что надо убрать")]), _vm._v("\n                   \n              "), _c('label', {
    attrs: {
      "for": "onlyNeedPlacement"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyAdd),
      expression: "onlyAdd"
    }],
    attrs: {
      "type": "checkbox",
      "id": "onlyNeedPlacement"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyAdd) ? _vm._i(_vm.onlyAdd, null) > -1 : (_vm.onlyAdd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyAdd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyAdd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyAdd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyAdd = $$c
        }
      }
    }
  }), _vm._v("\n                Только те, что еще не расставлены")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "table-holder"
  }, [_c('table', [_c('thead', [_c('tr', [_c('td', {
    staticClass: "id"
  }, [_vm._v("\n            ID\n\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "photo"
  }, [_vm._v("Фото")]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("\n            Название\n\n          ")]), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('td', {
    staticClass: "group"
  }, [_vm._v("\n            Кластер\n\n          ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.productList), function(product) {
    return _c('tr', {
      class: {
        'anti-facing': product.noFacing
      }
    }, [_c('td', {
      staticClass: "id"
    }, [_vm._v(_vm._s(product.groupId))]), _vm._v(" "), _c('td', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "photo-item",
      style: ({
        'background-image': ("url('" + (product.photos.FRONT) + "')")
      })
    })]), _vm._v(" "), _c('td', {
      staticClass: "title",
      on: {
        "dblclick": function($event) {
          return _vm.add(product)
        }
      }
    }, [_vm._v(_vm._s(product.title) + "\n          ")]), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('td', {
      staticClass: "group"
    }, [_vm._v(_vm._s(product.cluster ? product.cluster.title : ''))]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.next != null) ? _c('a', {
    ref: "next",
    staticClass: "more",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadNextPage.apply(null, arguments)
      }
    }
  }, [_vm._v("Еще товары")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "editor-field",
    class: _vm.roleClass
  }, [(_vm.$store.state.user.role === 'HM') ? _c('shelf', {
    attrs: {
      "initWidth": 800,
      "initHeight": 400,
      "initDepth": 300,
      "x": 0,
      "zoom": 2,
      "id": this.$route.params.shelf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.role !== 'HM') ? _c('shelfView', {
    attrs: {
      "initWidth": 800,
      "initHeight": 400,
      "initDepth": 300,
      "x": 0,
      "zoom": 2,
      "id": this.$route.params.shelf
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d647033","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shelf/Shelf.vue
// module id = 246
// module chunks = 1